<template>
  <div class="about" style="position: relative" :dir="isHebrew ? 'rtl' : 'ltr'" :lang="isHebrew ? 'he' : 'en'">
    <title>{{ t('aboutPageTitle') }}</title>
    <SingleRideHeader :presentedText="t('about')" />
    <b-container>
      <div class="about-page-section after_page_header">
        <div class="container">
          <div class="row about-page-main-row">
            <div class="about-page-text-col">
              <div class="about-page-content">
                <h1>{{ t('aboutPageTitle') }}</h1>
                <p class="about-lead">{{ t('aboutLead') }}</p>
                <p>{{ t('aboutBody1') }}</p>
                <p>{{ t('aboutBody2') }}</p>
                <p>{{ t('aboutBody3') }}</p>
                <p>{{ t('aboutBody4') }}</p>
                <p>{{ t('aboutBody5') }}</p>
                <p>{{ t('aboutBody6') }}</p>
                <p>{{ t('aboutBody7') }}</p>
                <p>{{ t('aboutBody8') }}</p>
                <p>{{ t('aboutBody9') }}</p>
              </div>
            </div>
            <div class="about-page-image-col">
              <div class="about-page-thumb">
                <img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fphone_display_app.png?alt=media&token=ccfc9989-224e-40be-ae57-aa6ed4db8637" class="rounded-image" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="about-page-cta-section">
        <div class="container">
          <div class="about-page-cta-wrap">
            <h2>{{ t('aboutContactTitle') }}</h2>
            <div class="about-page-cta-menu">
              <ul>
                <li><a href="tel:+972526867915">{{ t('aboutPhoneLabel') }}: {{ t('aboutPhoneNumber') }}</a></li>
                <li>|</li>
                <li><a href="mailto:avshalom@tripplanner.co.il">{{ t('aboutEmailLabel') }}: avshalom@tripplanner.co.il</a></li>
                <li>|</li>
                <li><a href="#">{{ t('aboutAddressLabel') }}: {{ t('aboutAddress') }}</a></li>
              </ul>
            </div>
            <div class="about-page-social">
              <ul>
                <li><a href="https://wa.me/972526867915" target="_blank" rel="noopener noreferrer"><img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FDigital_Glyph_Green.svg?alt=media&token=3e052f4e-d82e-482b-b2ed-e3694f2fae1c" alt="" width="32" height="32"></a></li>
                <li><a href="https://www.facebook.com/tripplanner.co.il"><img src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FFacebook_Logo_Primary.png?alt=media&token=2731adce-75a0-493d-ac5d-94a2913b2aa4" alt="" width="32" height="32"></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </b-container>
    <PageFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { translationMixin } from "@/mixins/translationMixin";
import PageFooter from "@/components/PageFooter.vue";
import SingleRideHeader from "@/components/SingleRideHeader";

export default {
  name: "AboutPage",
  mixins: [translationMixin],
  components: {
    PageFooter,
    SingleRideHeader,    
  },
  computed: {
    ...mapGetters(['globalRides', 'userId'])
  },
  methods: {},
  metaInfo() {
    return {
      title: 'TripPlanner',
      link: [
        { property: 'og:title', content: 'TripPlanner' },
        { property: 'og:description', content: this.t('aboutMetaDescription') },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: `https://tripplanner.co.il/about` },
        { name: 'description', content: this.t('aboutMetaDescription') },
      ]
    };
  }
}
</script>

<style scoped>
h1, h2 {
  color: #0d2f29;
  font-weight: 700;
}

h1 {
  font-size: 3.4rem;     /* larger main title */
  margin-bottom: 1.2rem;
}

h2 {
  font-size: 2.6rem;     /* clear subtitle */
  margin-top: 2.2rem;
  margin-bottom: 1rem;
}

.about-lead {
  font-weight: 600;
  color: #0d2f29;
}

p, li {
  font-size: 1.8rem;     /* clearly enlarged regular text */
  line-height: 2;
  color: #444;
  margin-bottom: 1.2rem;
}

ul {
  padding-inline-start: 4.5em;
  list-style: disc;
}

.about-page-content {
  margin-inline-start: 40px;
  text-align: start;
}

.about-page-thumb img {
  max-width: 100%;
  max-height: 800px;
  border-radius: 1rem;
}

.about-page-cta-wrap {
  background-color: #e6f7fa;
  border-radius: 16px;
  padding: 2.5rem;
  margin-top: 3rem;
  text-align: center;
}

.about-page-cta-wrap h2 {
  font-size: 2.4rem;  /* also bottom title more emphasized */
  margin-bottom: 1.4rem;
}

.about-page-cta-menu ul,
.about-page-social ul {
  padding: 0;
  margin: 1.5rem 0;
  list-style: none;
}

.about-page-cta-menu ul li,
.about-page-social ul li {
  display: inline-block;
  margin: 0 0.8em;
  font-size: 1.6rem;
}

a {
  color: #007bff;
  text-decoration: none;
  font-size: 1.8rem;
}

a:hover {
  text-decoration: underline;
}

.row {
  margin-top: 60px;
}

.about-page-main-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.about-page-text-col,
.about-page-image-col {
  padding-left: 15px;
  padding-right: 15px;
}

.about-page-text-col {
  flex: 0 0 70%;
  max-width: 70%;
}

.about-page-image-col {
  flex: 0 0 30%;
  max-width: 30%;
}

.about-page-thumb {
  display: flex;
  justify-content: center;
  width: 100%;
}

@media (max-width: 768px) {
  h1 {
    font-size: 2.4rem;
  }

  h2,
  .about-page-cta-wrap h2 {
    font-size: 1.8rem;
  }

  p, li {
    font-size: 1.7rem;
    line-height: 1.6;
  }

  .about-page-cta-menu ul li,
  .about-page-social ul li,
  a {
    font-size: 1.7rem;
  }

  .about-page-text-col,
  .about-page-image-col {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .about-page-content {
    margin-left: 0;
    padding: 0 1rem;
  }

  .about-page-cta-wrap {
    padding: 1.5rem;
  }

  .row{
  margin-top: 25px ;
  }

}

</style>
